import { useCallback } from 'react';
import { runInFlightRequest } from '../orchestration/requestRegistry';

export default function useSingleFlightRequests() {
    return useCallback(runInFlightRequest, []);
}
